import { Reveal } from "@/components/motion/Reveal";
import { Rich } from "@/components/common/Rich";
import { WhatsAppIcon } from "@/components/common/WhatsAppIcon";
import { EnquiryForm } from "./EnquiryForm";
import { whatsappLink } from "@/lib/whatsapp";

// Two-column wrapper: intro on the left, form card on the right.
export const FormSection = ({ id, intro, config, idPrefix, initialValues }) => (
  <section id={id} className="section-y scroll-mt-24 border-t border-line" data-testid={`${idPrefix}-section`}>
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <div className="lg:sticky lg:top-28">
          <p className="eyebrow mb-5">{intro.eyebrow}</p>
          <h2 className="h-section">{intro.title}</h2>
          <p className="lead mt-6">
            <Rich text={intro.body} />
          </p>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 text-[15px] font-medium text-accent underline-offset-4 hover:underline"
            data-testid={`${idPrefix}-direct-whatsapp`}
          >
            <WhatsAppIcon className="h-5 w-5" /> Or message SPC on WhatsApp
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <div className="relative border border-line bg-surface p-6 sm:p-10">
          <EnquiryForm config={config} idPrefix={idPrefix} initialValues={initialValues} />
        </div>
      </Reveal>
    </div>
  </section>
);
